import { IRouter } from '@routers/interface';
import React from 'react';

export const routerViewProfile: IRouter = {
  path: '/profile',
  name: 'profile.name',
  loader: React.lazy(() => import('./index')),
  exact: true,
  masterLayout: true,
};
